import type { ConfigObject } from '../../_configs/types';
import checkUndefinedNullOrEmpty from '../tools/checkUndefinedNullOrEmpty';

export default function generateTitle(titleStr: string, noLimit: boolean, settings: ConfigObject) {
    const title = [];
    const lengthStaticTitle = noLimit
        ? 0
        : (!checkUndefinedNullOrEmpty(settings?.general?.metaTitlePrefix)
              ? settings?.general?.metaTitlePrefix.length + (!checkUndefinedNullOrEmpty(settings?.general?.metaTitleSeperator) ? settings?.general?.metaTitleSeperator.length : 3) + 2
              : 0) +
          (!checkUndefinedNullOrEmpty(settings?.general?.metaTitleSuffix)
              ? settings?.general?.metaTitleSuffix.length + (!checkUndefinedNullOrEmpty(settings?.general?.metaTitleSeperator) ? settings?.general?.metaTitleSeperator.length : 3) + 2
              : 0);
    if (!checkUndefinedNullOrEmpty(settings?.general?.metaTitlePrefix)) title.push(settings?.general?.metaTitlePrefix);
    if (!checkUndefinedNullOrEmpty(titleStr)) title.push(titleStr?.substring(0, 60 - lengthStaticTitle));
    if (!checkUndefinedNullOrEmpty(settings?.general?.metaTitleSuffix)) title.push(settings?.general?.metaTitleSuffix);

    return title.join(settings?.general?.metaTitleSeperator);
}
